import { FC } from "react";
import Notifications from "@material-ui/icons/Notifications";
import { Badge, IconButton } from "@material-ui/core";
import { useStyles } from "./styles";
import { DaNotificationsDrawer } from "components/drawers/DaNotificationsDrawer";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { DaNotificationData } from "types/DaNotifications";
import { setNotificationsDrawerState } from "actions/notificationsActions";
import { useDispatch } from "react-redux";

interface NotificationButtonProps {}

export const DaNotificationButton: FC<NotificationButtonProps> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isDrawerOpen, notificationsList } = useTypeSelectors((state) => state.daNotificationsState);

  return (
    <>
      <Badge
        className={classes.badge}
        badgeContent={
          notificationsList.filter((notification: DaNotificationData) => !notification.is_read).length
        }
        color="error"
      >
        <IconButton className={classes.notificationButton} onClick={() => dispatch(setNotificationsDrawerState(!isDrawerOpen))}>
          <Notifications />
        </IconButton>
      </Badge>
      <DaNotificationsDrawer open={isDrawerOpen} onClose={() => dispatch(setNotificationsDrawerState(!isDrawerOpen))} />
    </>
  );
};
